export const iconFontAwesomeFilesFileArrowUp = (
	<i className="fa-solid fa-file-arrow-up"></i>
);
